import gql from 'graphql-tag';

export const updateCompany = gql`
  mutation updateCompany($id: String!, $changes: CompanyDataTableInput) {
    updateCompany(id: $id, changes: $changes) {
      id
      name
      abbreviation
      enabled
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
`;
